<template>
  <div class="modal-container clearfix">
    <vxe-table
        ref="xTable"
        stripe
        class="table-style"
        align="center"
        highlight-hover-row
        max-height="380"
        border="none"
        :loading="loading"
        show-footer
        :data="tableData"
        auto-resize
    >
      <vxe-table-column field="id" title="序号" width="100"></vxe-table-column>
      <vxe-table-column field="taxComp" title="税务机关名称"></vxe-table-column>
      <vxe-table-column field="opt" title="操作">
        <template slot-scope="{ row }">
          <a style="cursor: pointer;color: #348ef0;" @click="linkAcc(row)">关联客户</a>
          <a style="cursor: pointer;margin-left: 10px;color: #348ef0;" @click="goUpdate(row)">编辑</a>
          <a style="cursor: pointer;margin-left: 10px;color: #f40815;" @click="commitDelete(row.id)">删除</a>
        </template>
      </vxe-table-column>
    </vxe-table>
    <div class="modal-footer add-btn-box">
      <Button type="primary" style="width: 100px" @click="close">确 定</Button>
    </div>
    <vxe-modal v-model="linkVisible" title="添加关联企业客户" width="600" height="500" @close="closeLink" resize
               position="center">
      <add-link ref="linkModal" @close="closeLink"></add-link>
    </vxe-modal>
    <vxe-modal v-model="taxVisible" title="编辑税务机关" width="500" height="200" @close="closeTax" resize
               position="center" destroy-on-close>
      <add-tax ref="taxModal" @close="closeTax(1)"></add-tax>
    </vxe-modal>
  </div>
</template>
<script>

import $api from "@/apiProvider";
import AddLink from "@/components/tax/AddLink";
import AddTax from "@/components/tax/AddTax"
import {showLoading, hideLoading} from "@/utils/util";

export default {
  components: {AddLink, AddTax},
  data() {
    return {
      loading: false,
      tableData: [],
      linkVisible: false,
      taxVisible: false,
      curName: ''
    }
  },
  methods: {
    init() {
      this.getTaxList();
    },
    async getTaxList() {
      showLoading();
      let res = await $api.tax.post('getTaxList', {});
      hideLoading();
      if (res.status === 1) {
        this.tableData = res.data;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    closeLink() {
      this.linkVisible = false;
    },
    goUpdate(row) {
      this.taxVisible = true;
      this.$nextTick(()=>{
        this.$refs.taxModal.setUpdate(row);
      })
    },
    commitDelete(id) {
      this.$XModal.confirm("删除后不可恢复,是否删除税务机关?").then(type => {
        if (type === "confirm") {
          this.delete(id)
        }
      });
    },
    async delete(id) {
      showLoading();
      let res = await $api.tax.post('delTax', {
        id: id
      });
      hideLoading();
      if (res.status === 1) {
        this.$Message.success("删除成功");
        this.getTaxList();
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    linkAcc(row) {
      this.linkVisible = true;
      this.$refs.linkModal.init(row);
    },
    close() {
      this.$emit('close');
    },
    closeTax(e) {
      this.taxVisible = false;
      if (e) {
        this.getTaxList();
      }
    },
  }
}
</script>
<style scoped>
.modal-footer {
  padding: 10px 0;
  display: flex;
  justify-content: flex-end;
  width: 96%;
  position: absolute;
  bottom: 0;
}
</style>